import { queryOptions } from "@tanstack/react-query";
import { fetchPeople } from "../people";
import type { PeopleClient } from "../rpc/people";

/**
 * Keyed by user, like every identity read, so a second sign-in never reads the first's firm. The
 * Members page and the Settings index's badge read through this one key, which is what makes the
 * list, its counts and the badge agree: they are counted from the same answer.
 */
export function peopleQueryOptions(userId: string, client?: PeopleClient) {
  return queryOptions({
    queryKey: ["people", userId] as const,
    queryFn: ({ signal }) => fetchPeople(signal, 10000, client),
    retry: false,
  });
}
